import React, { createContext, useContext, useMemo } from 'react';
import { createProviderServices, ProviderServices } from '../../services/chat/createProviderServices';

interface AppServicesContextValue {
    providerServices: ProviderServices;
}

const AppServicesContext = createContext<AppServicesContextValue | undefined>(undefined);

interface AppServicesProviderProps {
    children: React.ReactNode;
}

export const AppServicesProvider: React.FC<AppServicesProviderProps> = ({ children }) => {
    const providerServices = useMemo(() => createProviderServices(), []);

    return <AppServicesContext.Provider value={{ providerServices }}>{children}</AppServicesContext.Provider>;
};

export const useAppServices = (): AppServicesContextValue => {
    const context = useContext(AppServicesContext);

    if (!context) {
        throw new Error('useAppServices must be used within AppServicesProvider.');
    }

    return context;
};

export const useProviderServices = (): ProviderServices => {
    return useAppServices().providerServices;
};

export const useProviderServicesRouter = () => {
    return useProviderServices().providerServicesRouter;
};

export const useProGPTServices = () => {
    return useProviderServices().proGPT;
};

export const useNexusServices = () => {
    return useProviderServices().nexus;
};

export const useAssistantsServices = () => {
    return useProviderServices().assistants;
};

export default AppServicesContext;
